const getters = {
  token: state => state.user.token,
  user: state => state.user.user,
  sidebarCollapse: state => state.app.sidebarCollapse,
  internetStatus: state => state.app.internetStatus,
  snackbar: state => state.app.snackbar,
  hostName: state => state.app.hostName
}
export default getters
